import React from "react";
import cx from "classnames";
import styles from "./styles.css";
function Link({ href, className, content }) {
    return (React.createElement("a", { href: href, className: cx(styles.link, className), target: "_blank", rel: "nofollow noopener" }, content));
}
export default Link;
